import gql from 'graphql-tag';
const WHACK_A_MOLE_ACTIVITY_FRAGMENT = gql `
  fragment WhackAMoleActivityFragment on WhackAMoleActivity {
    rounds {
      roundIndex
      randomizeCount
      steps {
        stepIndex
        word
        order
        optionalAnswer: answer
        stepType
      }
    }
  }
`;
export default WHACK_A_MOLE_ACTIVITY_FRAGMENT;
